import React, { useEffect, useState } from 'react';
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd';
import { taskStatus } from './initialData';
import { UncontrolledTooltip } from 'reactstrap';
import AnimatedCounter from './AnimatedCounter';
import { useSelector } from 'react-redux';

const onDragEnd = (result, columns, setColumns) => {
    if (!result.destination) return;
    const { source, destination } = result;

    if (source.droppableId !== destination.droppableId) {
        const sourceColumn = columns[source.droppableId];
        const destColumn = columns[destination.droppableId];
        const [removed] = sourceColumn.splice(source.index, 1);
        destColumn.splice(destination.index, 0, removed);
        setColumns({
            ...columns,
            [source.droppableId]: sourceColumn,
            [destination.droppableId]: destColumn
        });
    } else {
        const column = columns[source.droppableId];
        const [removed] = column.splice(source.index, 1);
        column.splice(destination.index, 0, removed);
        setColumns({
            ...columns,
            [source.droppableId]: column
        });
    }
};

export default function FreightStats() {
    const { dashboard_inquery_summery, dashboardFreightLeadStatsData } = useSelector((state) => state?.sales);
    const [columns, setColumns] = useState(dashboard_inquery_summery?.taskStatus || []);

    useEffect(() => {
        setColumns(3);
    }, [dashboard_inquery_summery]);

    const onDragEnd = (result, columns, setColumns) => {
        // Handle reordering here
    };

    return (
        <>
            <DragDropContext onDragEnd={(result) => onDragEnd(result, columns, setColumns)}>
                <Droppable droppableId="fkey">
                    {(provided) => (
                        <div ref={provided.innerRef} {...provided.droppableProps}>
                            <Draggable draggableId="f_0_1" index={1}>
                                {(provided) => (
                                    <div
                                        ref={provided.innerRef}
                                        {...provided.draggableProps}
                                        {...provided.dragHandleProps}
                                        className="sh_revenue_summary_wrap"
                                    >
                                        <h3 className="sub_title">Freight Leads</h3>
                                        <div className="sh_summary_box" key={1}>
                                            <p className="sh_summ_title d-flex align-items-center">
                                                Leads Received
                                                <span className="step-icon ms-1" data-bs-toggle="tooltip" id={`tooltip_0`}>
                                                <i className="mdi mdi-information"></i>
                                                <UncontrolledTooltip placement="right" target={`tooltip_0`}>
                                                  {dashboardFreightLeadStatsData?.totalInquiry || 0} Total Freight Leads Received
                                                </UncontrolledTooltip>
                                              </span>
                                            </p>
                                            <div className="sh_sum_rate justify-content-between">
                                                  <span>
                                                    <AnimatedCounter rate={dashboardFreightLeadStatsData?.totalInquiry || 0} />
                                                  </span>
                                                <div className="text-nowrap">
                                                    <span className="ms-1 box_bottom_text">Since last month</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="sh_summary_box" key={2}>
                                            <p className="sh_summ_title d-flex align-items-center">
                                                Leads Participated
                                                <span className="step-icon ms-1" data-bs-toggle="tooltip" id={`tooltip_1`}>
                                                <i className="mdi mdi-information"></i>
                                                <UncontrolledTooltip placement="right" target={`tooltip_1`}>
                                                  {dashboardFreightLeadStatsData?.totalBidSubmitted || 0} Total Freight Leads Apply
                                                </UncontrolledTooltip>
                                              </span>
                                            </p>
                                            <div className="sh_sum_rate justify-content-between">
                                                  <span>
                                                    <AnimatedCounter rate={dashboardFreightLeadStatsData?.totalBidSubmitted || 0} />
                                                  </span>
                                                <div className="text-nowrap">
                                                    <span className="ms-1 box_bottom_text">Since last month</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="sh_summary_box" key={3}>
                                            <p className="sh_summ_title d-flex align-items-center">
                                                Leads Won
                                                <span className="step-icon ms-1" data-bs-toggle="tooltip" id={`tooltip_2`}>
                                                <i className="mdi mdi-information"></i>
                                                <UncontrolledTooltip placement="right" target={`tooltip_2`}>
                                                  {dashboardFreightLeadStatsData?.totalBidWon || 0} Total Freight Lead Won
                                                </UncontrolledTooltip>
                                              </span>
                                            </p>
                                            <div className="sh_sum_rate justify-content-between">
                                                  <span>
                                                    <AnimatedCounter rate={dashboardFreightLeadStatsData?.totalBidWon || 0} />
                                                  </span>
                                                <div className="text-nowrap">
                                                    <span className="ms-1 box_bottom_text">Since last month</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </Draggable>
                            {provided.placeholder}
                        </div>
                    )}
                </Droppable>
            </DragDropContext>
        </>
    )
}
